// extracted by mini-css-extract-plugin
module.exports = {"plusIco":"AnswersBox_plusIco__1aCDh","inputGroup":"AnswersBox_inputGroup__3b0aw","label":"AnswersBox_label__3AayJ","error":"AnswersBox_error__kiXqs"};